export default "__VITE_ASSET__DaJCG3gO__"